import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "answers"]

  disableSubmit(event) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("loading")
      this.submitButtonTarget.textContent = "Envoi..."
    }
  }
}
